import { DataDisplayEvent, Label } from "@mcleod/components";
import { AutogenLayoutBalanceData } from "./autogen/AutogenLayoutBalanceData";

export class BalanceData extends AutogenLayoutBalanceData {

    onBalanceDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        const balance = this.activeRow.get(label.field, 0);
        label.color = balance < 0 ? "red" : "black";
    }

}
